import { createTextMarker, getScaledFontSize, getTextFormat, } from 'app/core/markers/models';
import { ProjectActions } from 'app/stores/project/actions';
import { getInsertStyle } from 'app/stores/selectors';
import { DefaultTextValues, measureText } from 'app/utils/text';
export const InsertText = (defaults, overrides) => (dispatch, getState) => {
    const state = getState();
    const { size, color, sizeFactor } = getInsertStyle(state);
    const onDragStart = (payload, point) => {
        const fontSize = getScaledFontSize(size, sizeFactor);
        const format = getTextFormat(fontSize, defaults.fontFamily);
        const text = DefaultTextValues.singleline;
        const { lines, width, height } = measureText(text, format);
        const markerProto = {
            x: point.x,
            y: point.y,
            lines,
            width,
            height,
            format,
            size,
            color,
        };
        if ((overrides === null || overrides === void 0 ? void 0 : overrides.type) === 'cloud') {
            const pinned = configGet('pinNoteAnchor', false);
            // NOTE: tail offset is relative to bounding TL
            const tailOffset = { x: width * 0.75 + 2, y: height + 20 };
            const cloud = Object.assign(Object.assign({}, overrides), { type: 'cloud', data: null, radius: 0.15, tail: pinned
                    ? {
                        x: point.x + tailOffset.x,
                        y: point.y + tailOffset.y,
                    }
                    : tailOffset });
            if (pinned) {
                cloud.pinned = true;
            }
            markerProto.background = cloud;
        }
        const marker = createTextMarker(markerProto);
        payload.itemId = marker.id;
        dispatch(ProjectActions.itemInsert({
            marker,
            undoable: true,
        }));
    };
    const onDrag = (payload, point) => {
        const { itemId: id } = payload;
        if (id) {
            dispatch(ProjectActions.itemUpdate({
                id,
                patch: {
                    x: point.x,
                    y: point.y,
                },
                undoable: false,
            }));
        }
    };
    const onDragEnd = (payload, _point) => {
        const { itemId: id } = payload;
        if (id) {
            dispatch(ProjectActions.itemSelect({
                id,
            }));
        }
    };
    return {
        onPointerDown: onDragStart,
        onPointerDrag: onDrag,
        onPointerUp: onDragEnd,
    };
};
